export const interactiveDemoHotspotGql = `
hotspotEntry {
    ... on interactiveDemoHotspot_interactiveDemoHotspot_Entry {
        interactiveDemoDescription
        interactiveDemoEyebrow
        interactiveDemoHeader
        tooltip:interactiveDemoTooltip
        interactiveDemoLink {
            url
            target
            text
            customText
            ariaLabel
        }
        interactiveDemoMedia {
            ... on videoUploads_Asset {
                videoUrl:url
            }
            ... on images_Asset {
                image:uncropped1920w {
                    srcset
                    srcWebp
                }
            }
            ... on videos_Asset {
                youtubePoster:url
                youtubeId:videoId
                youtubeDescription:videoDescription
            }
        }
    }
}`;
